import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';
import { makeAutoObservable } from 'mobx';
import CheckinRelation from 'main/stores/performance/CheckinRelation';

class RevieweesContainerState {
  store = new DomainStore();

  pairs;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.EMPLOYEES.ALL,
      endpoints.PERFORMANCE.REVIEWEES
    ]);
    this.pairs = this.store._getAll(types.PERFORMANCE.CHECKIN_RELATIONS, CheckinRelation);
  }
}

export default RevieweesContainerState;
